module.exports = __webpack_public_path__ + "static/media/woosik.5d4ae659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/woosik.jpg
// module id = 44
// module chunks = 0